import Shield from "../svgs/shield";
import Check from "../svgs/check";
import Arrows from "../svgs/arrows";
import Wifi from "../svgs/wifi";

const content = {
    "intelligent-data-capture": {
        title: "Unlocking the Benefits of Intelligent Data Capture for Your Organization",
        "sub-title":
            "Intelligent capture empowers organizations to overcome several challenges caused by manual data entry by offering unmatched benefits like:",
        points: [
            {
                icon: <Arrows />,
                title: "Efficiency Boost with Reduced Overhead",
                description:
                    "By eliminating the need for manual data entry and processing, intelligent data capture minimizes overhead costs and allows your human resources to focus on more valuable tasks.",
            },
            {
                icon: <Wifi />,
                title: "Facilitating Seamless Collaboration for Remote Workers",
                description:
                    "Intelligent capture bridges the gap between remote workers, enabling dynamic interactions without being restricted by shared physical locations and work hours.",
            },
            {
                icon: <Shield />,
                title: "Enhanced Security Measures",
                description:
                    "Intelligent capture ensures secure content and document delivery to designated recipients, with strict access control. Robust security protocols are swiftly applied to incoming content, guarding against data loss and security breaches.",
            },
            {
                icon: <Check />,
                title: "Streamlined Operations Through Integration",
                description:
                    "Integration capabilities create a harmonious business software ecosystem where your data seamlessly syncs and updates across various platforms and applications. This eliminates the need for redundant data entry and the time wasted on searching for the right application to use.",
            },
        ],
    },
    integrations: {
        title: "Maximizing the Benefits of ECM Integrations for Your Organization",
        points: [
            {
                icon: <Arrows />,
                title: "Centralized Data Source",
                description:
                    "Integrating your ECM system with other business software and applications establishes a centralized repository for all your business content. This ensures everyone operates with current and pertinent data, promoting efficiency and consistency across your organization.",
            },
            {
                icon: <Wifi />,
                title: "Enhanced Mobility",
                description:
                    "ECM software integrations empower your mobile workforce to maintain connectivity and productivity. Using their smart devices, they can seamlessly access the ECM system and the relevant content required for their tasks using their smart devices.",
            },
            {
                icon: <Shield />,
                title: "Intelligent Insights",
                description:
                    "Integrated data and content analytics provide deeper insights, facilitating informed decision-making processes for your organization.",
            },
            {
                icon: <Check />,
                title: "Streamlined Operations",
                description:
                    "Integrations enable the creation of a seamless business software ecosystem, automatically synchronizing and updating your business data across various platforms and applications. This reduces or eliminates redundant data entry and the time wasted searching for the right application, enhancing overall operational efficiency.",
            },
        ],
    },
    "document-and-records-management": {
        title: "Unlocking the Benefits of Document & Records Management for Your Organization",
        points: [
            {
                icon: <Arrows />,
                title: "Effective Record Generation and Growth Control",
                description:
                    "n an increasingly digitalized world, the volume of paperwork remains substantial. Document and records management tools empower your organization to take command of record creation and duplication, effectively managing their growth and reducing the storage space required.",
            },
            {
                icon: <Wifi />,
                title: "Streamlined Records Retrieval & Disposal",
                description:
                    "Misplacing records or spending excessive time searching for them can lead to detrimental consequences, including customer loss and wasted billable hours. A well-structured document and records management system simplifies records retrieval and ensures efficient disposal when their lifecycle concludes.",
            },
            {
                icon: <Shield />,
                title: "Ensuring Regulatory Compliance",
                description:
                    "Stringent compliance regulations make manual adherence a daunting task, potentially resulting in legal repercussions and hefty fines for non-compliance. An advanced records and document management system effortlessly ensures full compliance, eliminating the risk of regulatory breaches.",
            },
            {
                icon: <Check />,
                title: "Enhanced Information Security",
                description:
                    "Unauthorized access to sensitive data can lead to catastrophic consequences and potential theft. A document and records management system safeguards the confidentiality and integrity of your documents and records in accordance with your established rules. User-based roles and access levels restrict unauthorized users from accessing and tampering with critical information, ensuring its protection.",
            },
        ],
    },
    "process-automation": {
        title: "Key Benefits of Process Automation for Your Organization",
        points: [
            {
                icon: <Arrows />,
                title: "Enhanced Efficiency",
                description:
                    "Process automation significantly boosts your organization's efficiency, enabling processes to operate 24/7. Moreover, the system can handle bulk operations swiftly, reducing processing time. This automation results in error-free operations, enhancing overall accuracy.",
            },
            {
                icon: <Wifi />,
                title: "Increased Productivity",
                description:
                    "With automated tasks distributed among bots, your employees can redirect their focus to customer-centric activities rather than repetitive tasks. Process automation can be set up to run autonomously, freeing up valuable time for human-centered tasks.",
            },
            {
                icon: <Shield />,
                title: "Cost Savings",
                description:
                    "Automating repetitive tasks reduces wasted time and labor costs. The saved wages can be reinvested in other areas of your business, providing a higher return on investment.",
            },
            {
                icon: <Check />,
                title: "Enhanced Customer Satisfaction",
                description:
                    "Satisfied customers are a business's greatest asset. Process automation can significantly enhance the customer experience by expediting responses to queries and streamlining interactions such as order processing. This, in turn, leads to more satisfied and loyal customers.",
            },
        ],
    },
};

export default content;
